export const RESET_STORE = 'RESET_STORE';
export const BLOCK_UI = 'BLOCK_UI';
export const UN_BLOCK_UI = 'UN_BLOCK_UI';
export const INCREMENT_BLOCK_COUNTER = 'INCREMENT_BLOCK_COUNTER';
export const DECREMENT_BLOCK_COUNTER = 'DECREMENT_BLOCK_COUNTER';
export const SET_COOKIE = 'SET_COOKIE';
export const SET_CONFIG = 'SET_CONFIG'


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js